

































































































































































































import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import { debounce, isObject } from 'lodash';

import { mapGetters } from 'vuex';
import auth from '@/core/api/modules/auth';
import { trackPurchase, register, track } from '@/web/services/analytics';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import timezones from '@/web/utils/timezones.ts';
import { getConfig } from '@/web/utils/configuration';
import StudentLogin from '@/web/components/signup/StudentLogin.vue';
import { sanitize } from '@/core/utils/utils';
import { getTrackingParams } from '@/web/utils/tracking';

export default Vue.extend({
  components: { ValidationObserver },
  data() {
    return {
      subscriptionType: 'yearly',
      allPlansInclude: [
        'SIGNUP.TEXT.LIVE_STREAMING',
        'SIGNUP.TEXT.SET_YOUR_PRICING',
        'SIGNUP.TEXT.OFFER_COACHING',
        'SIGNUP.TEXT.NO_REV_SHARE',
        'SIGNUP.TEXT.SELL_COURSES',
        'SIGNUP.TEXT.INSTANT_PAYOUTS',
      ],
      selectedPlanId: null,
      teacherForm: {
        yoga_alliance_membership_id: '',
        studio_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_repeat: '',
      },
      coupon: null,
      couponError: null,
      inProgress: false,
      emailInfo: null,
      URLInfo: null,
      timezone: null,
      timezones,
      campaigns: {
        default: {
          title: 'SIGNUP.TITLE.CREATE_YOUR_ACCOUNT',
          subtitle: 'SIGNUP.TITLE.LETS_GET_YOU_SETUP',
        },
        appsumo: {
          title: 'SIGNUP.TITLE.CREATE_YOUR_APPSUMO_ACCOUNT',
          subtitle: 'SIGNUP.TITLE.LETS_GET_YOU_SETUP',
        },
        extaffiliate: {
          title: 'SIGNUP.TITLE.CREATE_YOUR_ACCOUNT',
          subtitle: 'SIGNUP.TITLE.LETS_GET_YOU_SETUP',
        },
      },
      isUsedEmail: false,
    };
  },
  props: {
    campaign: {
      type: String,
      default: 'default',
    },
    sale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'studentId',
      'teacher',
      'isLoggedIn',
      'hasSubscriptionType',
    ]),
    campaignData() {
      return this.campaigns[this.campaign];
    },
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
    isNamastreamDomain() {
      return window.location.host.toLowerCase().indexOf('namastream') !== -1;
    },
    signupTitle() {
      return this.$t(this.campaignData.title);
    },
    signupSutitle() {
      return this.$t(this.campaignData.subtitle);
    },
  },
  methods: {
    sanitize,
    openLoginModal() {
      this.$modal.show(StudentLogin, {});
    },
    async signup() {
      this.$refs.form.validate();
      const invalid = this.$refs.form?.flags?.invalid;
      if (invalid) {
        setTimeout(() => {
          scrollToFirstFormError();
        });
      }

      if (!this.coupon || !this.timezone || invalid || this.inProgress) {
        return;
      }

      let reCaptchaToken;
      try {
        const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'teachersignup',
        });
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.RECAPTCHA_FAILED'),
        });
      }

      this.inProgress = true;
      const data = {
        ...this.teacherForm,
        ...getTrackingParams(),
        signup_code: this.coupon,
        password1: this.teacherForm.password_repeat,
        timezone: this.timezone.value,
        token: reCaptchaToken,
      };

      try {
        if (this.isLoggedIn) await auth.promoteStudentToTeacherWithCode(data);
        else await auth.codeRegister(data);

        if (!this.isLoggedIn) await this.$store.dispatch('user/login', data);

        await this.$store.dispatch('user/loadUserInfo');

        const registerData = {
          first_name: this.teacher?.first_name,
          last_name: this.teacher?.last_name,
          email: this.teacher?.email,
          user_id: this.userId,
          student_id: this.studentId,
          studio_url: this.teacher?.studio_url,
          studio_name: this.teacher?.studio_name,
        };

        const traitsData = {
          coupon: this.coupon,
          affiliate_ref: '',
          campaign: this.campaign,
          studio_name: this.teacher?.studio_name,
        };

        register(this.userId, registerData);
        this.$trackOnPage('teacher code signed up', {
          ...registerData,
          ...traitsData,
        });
        trackPurchase(traitsData);

        this.$router.push({ name: 'thank-you' });
      } catch (error) {
        console.error(error);
        const errorMessage = errorToMessage(error.response);
        if (isObject(errorMessage)) {
          this.$refs.form.setErrors(errorMessage);
          scrollToFirstFormError();
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorMessage || error,
            duration: -1, // stay ON
          });
        }
        this.inProgress = false;
      }
    },
    setLocalTimeZone() {
      try {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = this.timezones.find(
          ({ value }) => value === localTimeZone
        );
        if (timezone) this.timezone = timezone;
      } catch (error) {
        console.error(error);
      }
    },
    setBrandColor(color) {
      const html = document.querySelector('html');
      html.style.setProperty('--brand-color', color);
    },
    async redirectIfTeacher() {
      await this.$store.state.user.userInfoPromise;
      if (this.teacher) {
        this.$router.replace({ name: 'settings-adjust-plan' });
      }
    },
  },
  watch: {
    'teacherForm.email': debounce(async function () {
      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyEmail(this.teacherForm.email);
          this.emailInfo = null;
        } catch (error) {
          this.emailInfo = this.$t('GENERAL.ERROR.ARE_YOU_SURE_THIS_EMAIL');
        }
      } else {
        this.emailInfo = null;
      }

      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyNewEmail(this.teacherForm.email);
          this.isUsedEmail = false;
        } catch (error) {
          this.isUsedEmail = true;
        }
      } else {
        this.isUsedEmail = false;
      }
    }, 400),
    affiliateCoupon: {
      handler(affiliateCoupon) {
        if (affiliateCoupon && affiliateCoupon.duration === 'forever') {
          this.coupon = this.affiliateCoupon.discount_coupon_code;
          this.applyCoupon();
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.redirectIfTeacher();
    if (this.isNamastreamDomain && process.env.NODE_ENV === 'production') {
      window.location.hostname = 'app.heymarvelous.com';
    }
    this.campaign = this.campaign || getConfig().signupCampaign;
    this.setLocalTimeZone();
    if (this.campaignData?.brandColor) {
      this.setBrandColor(this.campaignData.brandColor);
    }
  },
  destroyed() {
    this.setBrandColor(null);
  },
});
